// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1cK7H","approved":"Status_approved__2_gmC","rejected":"Status_rejected__1p3vK","expired":"Status_expired__q5re6","label":"Status_label__2zI6R"};